import { useEffect, useState, useCallback } from "react";
import { getRoom } from "../services/RoomService";
import { connectRoomSocket } from "../services/SocketService";

/**
 * Game-agnostic hook to fetch + subscribe to room updates via socket.
 */
export function useRoomRealtime(roomId, options = {}) {
  const { seatIndex, onSeatOccupied } = options;
  const [room, setRoom] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [seatPresence, setSeatPresence] = useState([]);

  const fetchRoom = useCallback(async () => {
    if (!roomId) return;
    try {
      setLoading(true);
      const data = await getRoom(roomId);
      setRoom(data);
      setError(null);
    } catch (err) {
      console.error("Failed to load room", err);
      setError("Failed to load room");
    } finally {
      setLoading(false);
    }
  }, [roomId]);

  useEffect(() => {
    fetchRoom();

    const disconnect = connectRoomSocket(roomId, (latestRoom) => {
      setRoom(latestRoom);
      setError(null);
      setLoading(false);
    }, {
      seatIndex,
      onPresence: (payload) => {
        setSeatPresence(payload.connectedSeatIndices || []);
      },
      onSeatOccupied: () => {
        setError("Seat already in use on another device/tab");
        onSeatOccupied?.();
      }
    });

    return () => {
      if (disconnect) disconnect();
    };
  }, [roomId, fetchRoom, seatIndex, onSeatOccupied]);

  return { room, loading, error, reload: fetchRoom, seatPresence };
}
